import { DateTime } from "luxon";

function formatearFecha(fecha) {
  let fechaFormat = fecha;
try
{
  if (fecha != null && fecha.length>0) {
    const opcionesDeFormato = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const [dia, mes, anio] = new Intl.DateTimeFormat('es-ES', opcionesDeFormato)
      .format(new Date(fecha))
      .split('/');
    fechaFormat = `${dia}/${mes}/${anio}`;
  }
}
catch (e) {
  console.error("fecha con error: ", fecha, e);
}
  return fechaFormat;
}

function formatearFechaString(fecha) {
  let fechaFormat = fecha;

  try {
    if (fecha != null) {
      if (fecha instanceof Date) {
        // Si fecha es un objeto Date, conviértelo a cadena
        const opcionesDeFormato = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const [dia, mes, anio] = new Intl.DateTimeFormat('es-ES', opcionesDeFormato)
          .format(fecha)
          .split('/');
        fechaFormat = `${dia}/${mes}/${anio}`;
      } else {
        // Si fecha es una cadena, no hagas nada
      }
    }
  } catch (e) {
    console.error("fecha con error: ", fecha, e);
  }
  return fechaFormat;
}


function formatearFechaUseStateInicial(fecha) {
  let fechaFormat = fecha;
  try {
    if (fecha != null) {
      if (fecha instanceof Date) {
        // Si fecha es un objeto Date, conviértelo a cadena
        const opcionesDeFormato = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const [dia, mes, anio] = new Intl.DateTimeFormat('es-ES', opcionesDeFormato)
          .format(fecha)
          .split('-');
        fechaFormat = `${anio}-${mes}-${dia}`;
      } else {
        // Si fecha es una cadena, no hagas nada
      }
    }
  } catch (e) {
    console.error("fecha con error: ", fecha, e);
  }

  return fechaFormat;
}

function formatearFechaLuxon(fecha, format) {
  let fechaFormat = fecha;

  try {
    if (fecha != null) {
      if (typeof fecha === 'string') {
        // Parsear la cadena en una instancia de DateTime de Luxon
        fechaFormat = DateTime.fromISO(fecha);
      } else if (fecha instanceof Date) {
        // Convertir el objeto Date a una instancia de DateTime de Luxon
        fechaFormat = DateTime.fromJSDate(fecha);
      }

      // Formatear la fecha con el formato del parametro
      fechaFormat = fechaFormat.toFormat(format);
    }
  } catch (e) {
    console.error("fecha con error: ", fecha, e);
  }

  return fechaFormat;
}


export {formatearFecha, formatearFechaString, formatearFechaUseStateInicial, formatearFechaLuxon}